import React from "react";

// Interior page hero.
// Provide either `bg` (a tailwind bg-* class) or `image` (an imported image URL).
export default function PageHero({ eyebrow, title, intro, bg = "bg-services-header", image, crumbs, actions }) {
  const style = image
    ? { backgroundImage: `url(${image})` }
    : undefined;
  return (
    <header
      className={`${image ? "" : bg} relative bg-ink bg-blend-multiply bg-center bg-cover bg-no-repeat mt-[30px] lg:mt-[40px]`}
      style={style}
    >
      <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/45 to-ink/25" />
      <div className="grain relative max-w-site mx-auto px-5 sm:px-10 pt-32 pb-16 md:pt-44 md:pb-24">
        <div className="mb-8">{crumbs}</div>
        {eyebrow && <p className="eyebrow eyebrow--light mb-5">{eyebrow}</p>}
        <h1 className="text-white font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl">
          {title}
        </h1>
        {intro && (
          <p className="text-paper/85 text-lg leading-7 mt-6 max-w-2xl">{intro}</p>
        )}
        {actions && <div className="flex flex-wrap gap-4 mt-8">{actions}</div>}
      </div>
    </header>
  );
}
